import { render, staticRenderFns } from "./ComplementarySession.vue?vue&type=template&id=da85f148"
import script from "./ComplementarySession.vue?vue&type=script&lang=js"
export * from "./ComplementarySession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports